import React from 'react';
import { capitalizeFirstLetter } from 'formatters';
import { Stack, Typography } from '@mui/material';

import { EMPTY_VALUE, formatCurrencyText, formatEnumText, getChangeAction } from './lib';
import { Details } from './Details';

interface Props {
  value: Record<string, any>;
}

const formatText = (text: string | null | undefined): string => text || EMPTY_VALUE;

const getDepositRows = (
  before: Record<string, any> | null | undefined,
  after: Record<string, any> | null | undefined
) => [
  {
    label: 'Amount',
    before: formatCurrencyText(before?.value),
    after: formatCurrencyText(after?.value),
    rawBefore: before?.value,
    rawAfter: after?.value,
  },
  {
    label: 'Type',
    before: formatEnumText(before?.type),
    after: formatEnumText(after?.type),
    rawBefore: before?.type,
    rawAfter: after?.type,
  },
  {
    label: 'Notes',
    before: formatText(before?.notes),
    after: formatText(after?.notes),
    rawBefore: before?.notes,
    rawAfter: after?.notes,
  },
];

export const DepositChanges = ({ value }: Props) => {
  const before = value?.before ?? null;
  const after = value?.after ?? null;

  const action = getChangeAction(before, after);

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" fontWeight={500}>
        {`${capitalizeFirstLetter(action)} deposit`}
      </Typography>

      <Details action={action} rows={getDepositRows(before, after)} />
    </Stack>
  );
};
